<template>
    <div class="af-form">
        <div
            class="afu-w-full afu-p-10 afu-bg-white afu-rounded-card afu-m-auto afu-w-100 afu-box-border"
            :class="{ 'afu-shadow-lg': !isModal }"
        >
            <div
                class="af-form"
                v-if="!submited"
            >
                <ValidationObserver
                    ref="saveUnsubscribeForm"
                    tag="form"
                    @submit.stop.prevent="onSubmit"
                >
                    <C1Label class="afu-text-center af-label afu-text-black afu-block afu-mb-20 af-text--8xl afu-font-bold">
                        <span> Are you sure you want to remove '{{ alert_name }}'?</span>
                    </C1Label>

                    <div class="afu-flex afu-items-center afu-justify-center afu-gap-2">
                        <C1Button
                            :disabled="loader.updating"
                            :is-busy="loader.updating"
                            type="submit"
                            variant="primary"
                            class="afu-flex-1"
                        >
                            <FontAwesomeIcon
                                :icon="['fal', 'trash-alt']"
                                class="afu-mr-2"
                                fixed-width
                            />
                            {{ $t('label.confirm_remove') }}
                        </C1Button>
                        <C1Button
                            :disabled="loader.updating"
                            variant="outline-secondary"
                            class="afu-flex-1"
                            @click="redirectToHome"
                        >
                            {{ $t('label.cancel') }}
                        </C1Button>
                    </div>
                </ValidationObserver>
            </div>

            <div v-else>
                <C1Alert :variant="response.variant">
                    <p class="afu-text-center afu-mb-0">
                        {{ response.message }}
                    </p>
                </C1Alert>
                <div class="afu-text-center afu-mt-5 md:afu-mt-10">
                    <a
                        :href="getLocalePath('/user-dashboard/job-alerts/')"
                        class="text-sm afu-text-primary-400 hover:afu-text-primary-400 afu-underline hover:afu-no-underline"
                    >
                        {{ $t('job_alert.manage') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import '@/plugins/vee-validate';
    import '../../plugins/vee-validate';
    import { ValidationObserver } from 'vee-validate';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1Label from '@/components/C1Components/C1Label';

    export default {
        name: 'UnsubscribeJobAlert',

        components: {
            ValidationObserver,
            C1Button,
            C1Alert,
            C1Label,
        },

        props: {
            isModal: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                response: {
                    variant: '',
                    message: '',
                },
                loader: {
                    updating: false,
                },
                submited: false,
                alert_name: '',
            };
        },

        async created() {
            await this.$recaptchaLoaded();
        },

        computed: {},

        watch: {},

        mounted() {
            const urlParams = new URLSearchParams(window.location.search);
            this.token = urlParams.get('token');
            this.alert_name = urlParams.get('alert_name');

            if (!this.token) {
                return;
            }
        },

        methods: {
            ...mapActions('user', {
                $_deleteJobAlert: 'deleteJobAlert',
            }),

            async onSubmit() {
                this.loader.updating = true;

                this.$_deleteJobAlert(this.token)
                    .then(response => {
                        if (response) {
                            this.response.variant = 'success';
                            this.response.message = this.$t('job_alert.success_remove');
                            this.submited = true;
                        }
                    })
                    .catch(() => {
                        this.response.message = this.$t('job_alert.not_found');
                        this.response.variant = 'danger';
                        this.submited = true;
                    })
                    .finally(() => {
                        this.loader.updating = false;
                    });
            },

            redirectToHome() {
                window.location.href = '/';
            },
        },
    };
</script>
<style lang="scss" scoped>
    .searchbar-typeahead {
        &::v-deep {
            .af-input-icon-x {
                top: 55%;
            }

            // .af-input {
            //     border: 0;
            // }
        }
    }
</style>
